module.exports = __webpack_public_path__ + "img/198.41d905f4.jpg";